module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "button-style": "success",
      "button-type": _vm.buttonType,
      "heading": "Pay Invoice",
      "buttonSize": "mini",
      "round": "",
      "button-size": "normal",
      "button-type": "buttonType",
      "button-text": "Payment",
      "button-icon": "fa fa-dollar-sign",
      "disable-save": true,
      "disableButton": _vm.disabled
    },
    on: {
      "on": function($event) {}
    }
  }, [_c('div', {
    staticClass: "padded",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-alert', {
    attrs: {
      "show-icon": "",
      "type": "info",
      "title": "Under Development",
      "description": "Still under design and development"
    }
  }), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-row', [_c('h3', [_vm._v("Payment")]), _vm._v("  \n        "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.full),
      callback: function($$v) {
        _vm.full = $$v
      },
      expression: "full"
    }
  }, [_vm._v("Full")]), _vm._v(" \n        "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.full),
      callback: function($$v) {
        _vm.full = $$v
      },
      expression: "full"
    }
  }, [_vm._v("Partial")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "padding-top": "1.2em"
    },
    attrs: {
      "inline": ""
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Date"
    },
    model: {
      value: (_vm.item.datePaid),
      callback: function($$v) {
        _vm.$set(_vm.item, "datePaid", $$v)
      },
      expression: "item.datePaid"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Ref"
    },
    model: {
      value: (_vm.item.paidRef),
      callback: function($$v) {
        _vm.$set(_vm.item, "paidRef", $$v)
      },
      expression: "item.paidRef"
    }
  }), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": "Amount",
      "disabled": !_vm.item.paid
    },
    model: {
      value: (_vm.item.amountPaid),
      callback: function($$v) {
        _vm.$set(_vm.item, "amountPaid", $$v)
      },
      expression: "item.amountPaid"
    }
  }), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": "Tax",
      "disabled": !_vm.item.paid
    },
    model: {
      value: (_vm.item.taxPaid),
      callback: function($$v) {
        _vm.$set(_vm.item, "taxPaid", $$v)
      },
      expression: "item.taxPaid"
    }
  }), _vm._v(" "), _c('currency-input', {
    attrs: {
      "label": "Total",
      "disabled": ""
    },
    model: {
      value: (_vm.totalPaid),
      callback: function($$v) {
        _vm.totalPaid = $$v
      },
      expression: "totalPaid"
    }
  }), _vm._v(" "), _c('check-box', {
    model: {
      value: (_vm.autoAllocate),
      callback: function($$v) {
        _vm.autoAllocate = $$v
      },
      expression: "autoAllocate"
    }
  }, [_vm._v("Allocate across " + _vm._s(this.full === '1' ? 'all items' : 'selected') + "?")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.full === '0') ? _c('el-transfer', {
    attrs: {
      "filterable": "",
      "titles": ['Line Items', 'Selected to Pay'],
      "filter-method": _vm.filterMethod,
      "filter-placeholder": "Refs",
      "data": _vm.refs
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21edad4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/payment/InvoicePayment.vue
// module id = 1367
// module chunks = 0